<template>
  <svg class="stroke-current w-8 h-8 mr-1 md:mr-3" viewBox="0 0 31.01 40.91" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-linejoin="round"><path d="m2.9 12.25v24.1a4 4 0 0 0 4 4.06h19.56a4 4 0 0 0 4.05-4v-31.71a4.2 4.2 0 0 0 -4.19-4.2h-6.74a1.73 1.73 0 0 0 -1 .35l-4.65 3.56a5 5 0 0 1 -3 1h-1.76z"/><path d="m5.92 3.08-5.42 5.92 2.8 2.8 5.42-5.92z"/><g stroke-linecap="round"><path d="m20.32 3.74h6.68"/><path d="m8.72 16.76 15.9 15.9"/><path d="m24.62 16.76-15.9 15.9"/></g></g></svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
